import React, { Component } from "react"
import { FaFacebookF, FaTwitter, FaGithub, FaInstagram, FaWhatsapp, FaLinkedinIn} from 'react-icons/all'
import axios from 'axios'


class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: '',
        }

        this.handleChange = this.handleChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = e => {
        this.setState( {[e.target.name]: e.target.value} )
    }

    async handleSubmit(e) {
        // e.preventDefault();

        const { name, email, subject, message } = this.state;

        const form = await axios.post ('api/form', {
            name,
            email,
            subject,
            message
        })
    }

   render() {
    return (
        <div id="contact">
            <div className="container">
                <div className="form">
                    <h1>Contact me</h1>
                    <form onSubmit={this.handleSubmit}>
                        <input type="text" id="name" name="name" placeholder="Name" required 
                        onChange={this.handleChange}
                        />
                        <input type="email" id="email" name="email" placeholder="email@example.com" required
                        onChange={this.handleChange}
                        />
                        <input type="text" id="subject" name="subject" placeholder="Subject"
                        onChange={this.handleChange}
                        />
                        <textarea id="message" name="message" placeholder="Enter your message" required
                        onChange={this.handleChange}
                        ></textarea>
                        <input type="submit" value="Send" id="submit"/>
                    </form>
                    <div>Or contact me via: <a href="mailto:bmsteve@yahoo.com">bmsteve@yahoo.com</a> <br/>or <a href="tel:+255655392445">+255 655 392 445</a></div>
                </div>
                <div className="follow">
                <a href="https://web.facebook.com/profile.php?id=100006234616525" rel="noopener noreferrer" target="_blank"><FaFacebookF /></a>
                <a href="https://www.twitter.com/bmsteve96" rel="noopener noreferrer" target="_blank"><FaTwitter /></a>
                <a href="https://www.github.com/bmsteven" rel="noopener noreferrer" target="_blank"><FaGithub /></a>
                <a href="https://www.linkedin.com/in/benedict-steven-646724122/" rel="noopener noreferrer" target="_blank"><FaLinkedinIn /></a>
                <a href="https://www.instagram.com/bensteve_" rel="noopener noreferrer" target="_blank"><FaInstagram /></a>
                <a href="http://wa.me/255655392445"><FaWhatsapp /></a>
                </div>
            </div>
        </div>
    );
   }
}

export default Contact;